import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import ListItem from "../../sub-components/Generic/ListItem/ListItem.vue";
import DateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";

const classes = {
  classHeader: "text-left",
  classField: "text-left"
};

const fieldNameCPF = [
  { field: "Customer.Name", class: "identity text-left" },
  { field: "Customer.Identity", type: "identity", class: "identity text-left" }
];

export default {
  name: "MerchantSubscription",
  components: {
    TableList,
    DateField,
    ListItem,
    decimalField
  },
  data() {
    return {
      step: 0,
      idMerchant: null,
      headers: [
        { field: "Id", label: "Código" },
        { field: "Plan.Name", label: "Plano", ...classes },
        { field: "PaymentMethod.Name", label: "Forma de pagamento", ...classes },
        { field: fieldNameCPF, label: "Cliente", ...classes },
        { field: "SubscriptionStatus.Code", type: "SubscriptionStatusText", label: "Status" },
        { field: "CreatedDate", label: "Data da assinatura", type: "date" }
      ],
      selectedSubscription: null,
      modalTitle: "Detalhes da Assinatura",
      pageName: "Assinaturas",
      permissionIsAuthorize: "Subscription",
      countFilter: 0,
      itemList: [],
      profiles: [],
      filter: {
        Id: null,
        Name: null,
        Identity: null,
        Plan: null,
        SubscriptionStatus: null,
        InitialDate: null,
        EndDate: null
      },
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },

      subscriptionStatus: [],
      plans: [],
      loadingMerchantSubscription: false,
      loadingSubscriptionStatus: false,
      loadingSubscription: false,
      loadingPlan: false,

      headersCharges: [
        { field: "IdTransaction", label: "Transação", ...classes },
        { field: "NameTransactionStatus", label: "Status", ...classes },
        { field: "ChargeDate", label: "Data", type: "dateTime" }
      ],
      headersHistory: [
        { field: "Id", label: "ID", ...classes },
        { field: "Code", label: "Status", type: "SubscriptionStatusText" },
        { field: "CreatedDate", label: "Data", type: "dateTime" }
      ]
    };
  },

  computed: {
    loadingExtras() {
      return this.loadingSubscriptionStatus || this.loadingPlan;
    }
  },

  mounted() {
    if (this.$route.params.idMerchant !== null && this.$route.params.idMerchant !== undefined) {
      this.idMerchant = this.$route.params.idMerchant;
    }

    this.ListSubscriptionStatus();
    this.ListPlan();
    this.ListMerchantSubscription();
  },

  methods: {
    hasValue(item) {
      return hasValue(item);
    },

    OpenField(item, index, eventName) {
      this.step = 0;
      this.GetSubscriptionStatus(item.Id);
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListMerchantSubscription();
    },

    ResetFilter() {
      this.filter = {
        Id: null,
        Name: null,
        Identity: null,
        Plan: null,
        SubscriptionStatus: null,
        InitialDate: null,
        EndDate: null
      };
      this.ListMerchantSubscription();
    },

    GetParamsListMerchantSubscription(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Plan.Merchant.Id": this.idMerchant,
        "Object.Id": this.filter.Id,
        "Object.Customer.Name": this.filter.Name,
        "Object.Customer.Identity": this.filter.Identity,
        "Object.Plan.Id": this.filter.Plan,
        "Object.SubscriptionStatus.Code": this.filter.SubscriptionStatus,
        InitialDate: this.filter.InitialDate,
        EndDate: this.filter.EndDate
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    GetSubscriptionStatus(id) {
      this.loadingSubscription = true;
      this.selectedSubscription = null;
      this.$bvModal.show("mMoreInfo");

      this.$store
        .dispatch("GetMerchantSubscription", { id: id, idMerchant: this.idMerchant })
        .then(response => {
          this.Paginator = response;
          this.selectedSubscription = response;
          this.selectedSubscription.Emails =
            this.selectedSubscription.Emails.length > 0 ? this.selectedSubscription.Emails.split(";") : [];
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao carregar as informações dessa assinatura. Tente novamente.",
            "danger",
            "Erro ao carregar assinatura.",
            error
          );
        })
        .finally(() => (this.loadingSubscription = false));
    },

    ListMerchantSubscription() {
      this.loadingMerchantSubscription = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => {
        if (hasValue(value)) this.countFilter++;
      });
      const params = this.GetParamsListMerchantSubscription();
      this.$store
        .dispatch("ListMerchantSubscription", params)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
          this.pagination.itemList = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar. Tente novamente.", "danger", "Erro ao listar.", error);
        })
        .finally(() => (this.loadingMerchantSubscription = false));
    },

    GetReport() {
      this.loadingMerchantSubscription = true;
      const params = this.GetParamsListMerchantSubscription(true);
      this.$store
        .dispatch("ReportMerchantSubscription", params)
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingMerchantSubscription = false;
          }, 1200);
        });
    },

    ListSubscriptionStatus() {
      this.loadingSubscriptionStatus = true;
      this.$store
        .dispatch("ListSubscriptionStatus", {})
        .then(response => {
          this.subscriptionStatus = response;
          this.subscriptionStatus.sort((a, b) => a.Name.localeCompare(b.Name));
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os Status de Assinaturas. Tente novamente.",
            "danger",
            "Erro ao listar os Status de Assinaturas",
            error
          );
        })
        .finally(() => (this.loadingSubscriptionStatus = false));
    },

    ListPlan() {
      this.loadingPlan = true;
      this.$store
        .dispatch("ListMerchantPlans", { params: { "Object.Merchant.Id": this.idMerchant } })
        .then(response => {
          this.plans = response.Objects;
          this.plans.sort((a, b) => a.Name.localeCompare(b.Name));
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os Planos. Tente novamente.",
            "danger",
            "Erro ao listar os Planos",
            error
          );
        })
        .finally(() => (this.loadingPlan = false));
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/MerchantSubscription/MerchantSubscription.js